const GIFT_PRODUCTS = {
  wrap: 50044212609301,
  box: 50046232953109,
  premium: 50046233248021
};

document.addEventListener("submit", async function (e) {

  const form = e.target;

  if (!form.matches('form[action*="/cart/add"]')) return;

  const packaging = form.querySelector("#gift-packaging")?.value || "";

  if (!packaging) return;

  let giftVariantId = GIFT_PRODUCTS.wrap;

  if (packaging.toLowerCase().includes("box")) {
    giftVariantId = GIFT_PRODUCTS.box;
  }

  if (packaging.toLowerCase() === "premium") {
    giftVariantId = GIFT_PRODUCTS.premium;
}

  setTimeout(async () => {

    const price = form.querySelector("#gift-price")?.value || "";
    const design = form.querySelector("#gift-design")?.value || "";
    const message = form.querySelector("#gift-message-hidden")?.value || "";

    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items: [{
          id: giftVariantId,
          quantity: 1,
          properties: {
            "Gift Packaging": packaging,
            "Gift Price": price,
            "Gift Design": design,
            "Gift Message": message
          }
        }]
      })
    });

    document.dispatchEvent(
      new CustomEvent("cart:refresh")
    );

  }, 700);

});